import IPMailButton from './IPMailButton'

export default IPMailButton
